import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  currentPage:any = 'home';
  lastMessageHistoryLength: number;
  constructor(private homeService: HomeService) { }

  ngOnInit() {
     this.homeService.homeHistory$.subscribe(value => {
      this.currentPage = value;
      console.log("this.currentPage --->",this.currentPage)
    });
    this.homeService.getLastMessageHistoryLength().subscribe(value => {  
      this.lastMessageHistoryLength = value; 
      console.log("lastMessageHistoryLength --->", this.lastMessageHistoryLength);
    });
  }

}
